/**
 * Классы типографики Evirma поверх токенов из `assets/styles/tailwind.css`.
 *
 * Страница берёт размер, насыщенность и межстрочный интервал отсюда и не пишет
 * числа в разметке: значение живёт в одном месте и меняется вместе с темой.
 */
export const typeClass = {
  /** Заголовок страницы, один на экран. */
  pageTitle:
    '[font-size:var(--type-page-title-font-size)] [font-weight:var(--type-page-title-font-weight)] [line-height:var(--type-page-title-line-height)]',
  /** Вопрос шага в пошаговой форме: крупнее основного текста, но мельче заголовка страницы. */
  blockTitle:
    '[font-size:var(--type-block-title-font-size)] [font-weight:var(--type-block-title-font-weight)] [line-height:var(--type-block-title-line-height)]',
  /** Заголовок блока внутри карточки: тот же размер, что и текст, но заметнее. */
  sectionTitle:
    '[font-size:var(--type-body-font-size)] [font-weight:var(--type-label-font-weight)] [line-height:var(--type-body-line-height)]',
  /** Основной текст. */
  body: '[font-size:var(--type-body-font-size)] [font-weight:var(--type-body-font-weight)] [line-height:var(--type-body-line-height)]',
  /** Подпись поля или значения. */
  label:
    '[font-size:var(--type-label-font-size)] [font-weight:var(--type-label-font-weight)] [line-height:var(--type-label-line-height)]',
  /** Пояснение рядом с основным текстом. */
  supporting:
    '[font-size:var(--type-supporting-font-size)] [font-weight:var(--type-supporting-font-weight)] [line-height:var(--type-supporting-line-height)]',
  /** Мелкая сопроводительная строка. */
  caption:
    '[font-size:var(--type-caption-font-size)] [font-weight:var(--type-caption-font-weight)] [line-height:var(--type-caption-line-height)]',
  /** Надзаголовок над названием раздела. */
  eyebrow:
    '[font-size:var(--type-eyebrow-font-size)] [font-weight:var(--type-eyebrow-font-weight)] [line-height:var(--type-eyebrow-line-height)]',
} as const
